export default "__VITE_ASSET__28f783c2__"